import React from 'react';
import { connect } from 'react-redux';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS } from 'src/constants/EndpointUrls';
import { setList } from 'src/reducers/common/editableListReducer';
import { REDUCER_NAME } from 'src/reducers/clients/employmentTypes';
import { getSelectOptions } from 'src/reducers/selectOptions';

import EditableListButtons from './containers/EditableListButtons';
import EditableListFormed from './containers/EditableListFormed';

const EmploymentTypesList = ({ clientEmploymentTypes, dispatch, anyApiRunning }) => {
  dispatch(setList(REDUCER_NAME, clientEmploymentTypes));
  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">雇用形態設定</h1>
      </div>
      <div className="l-wrap-xs l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label="設定" path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label="雇用形態設定" />
          </BreadCrumb>
        </div>
        <EditableListButtons anyApiRunning={anyApiRunning} />
        <EditableListFormed type="雇用形態" />
      </div>
    </div>
  );
};

export default connect(state => ({
  anyApiRunning: getSelectOptions(state, 'anyApiRunning')
}))(EmploymentTypesList);
